<template>
 <div style="padding-top: 1em;">
 <div v-html="formattedCGUText"></div>
    <b-field
      v-if="isActive !== null"
    >
      <b-button @click="accepteCGA">
        Accepter
      </b-button>
    </b-field>

    <b-field
      v-if="isActive !== null"
    >
      <b-button @click="refuse">
        Refuser
      </b-button>
    </b-field>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import cguText from '../../assets/configuration/CGA.js'
const fs = require('fs')
export default {
  data () {
    return {
      isActive: false,
      cguText: cguText,
    }
  },
  computed: {
    ...mapState(['user']),
    formattedCGUText () {
      return this.cguText.replace(/\n/g, '<br>')
    },
  },
  methods: {
    accepteCGA () {
      const url = window.location.href // Récupère l'URL de la page
      const parts = url.split('/')
      var user = this.user.name
      const id = parts[parts.length - 2]
      this.$store.dispatch('setCgaValue', {
        user: user,
        id: id,
        val: true
      })
    },
    refuse () {
      const url = window.location.href // Récupère l'URL de la page
      const parts = url.split('/')
      var user = this.user.name
      const id = parts[parts.length - 2]
      this.$store.dispatch('setCgaValue', {
        user: user,
        id: id,
        val: false
      })
    }
  },
}
</script>
